import React from 'react';
import _ from 'lodash';

import { styled } from '@mui/material/styles';
import { Delete } from '@mui/icons-material';
import {
  Avatar as BaseAvatar,
  Box,
  Button,
  IconButton as BaseIconButton,
  InputLabel
} from '@mui/material';

import { protectedFileUtil } from '../../../layer0';

import * as FileInputField from '../shared/FileInputField/FileInputField';

export type IFileData = FileInputField.IFileData;



const __avatarSize = '96px';

const OuterContainerDiv = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

const InnerContainerDiv = styled('div')(({theme}) => ({
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: 10,
  padding: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

const AvatarContainerDiv = styled('div')(({theme}) => ({
  position: 'relative',
  marginRight: theme.spacing(8)
}));

const Avatar = styled(BaseAvatar)(() => ({
  width: __avatarSize,
  height: __avatarSize
}));

const DeleteButtonContainerDiv = styled('div')(() => ({
  position: 'absolute',
  left: 83,
  top: '50%',
  transform: 'translateY(-50%)'
}));

const IconButton = styled(BaseIconButton)(({theme}) => ({
  backgroundColor: '#fff',
  border: `1px solid ${theme.palette.secondary.main}`,
  ':hover': {
    backgroundColor: theme.palette.secondary.main
  }
}));



export interface IProps {
  label?: string;
  initFileKey: string;
  fileData: IFileData | null | undefined;
  onChangeFileData: (fileData: IFileData | null) => void;
  isDisabled?: boolean;
}

export const FC: React.FC<IProps> = props => {
  const elAvatar = React.useMemo(
    () => {
      if (props.fileData) {
        return (
          <Avatar
            src={props.fileData.dataUrl} />
        );

      } else if (_.isUndefined(props.fileData) && props.initFileKey) {
        return (
          <protectedFileUtil.ProtectedImage.FC
            fileKey={props.initFileKey}
            asAvatar
            size={__avatarSize}
            disableLightBox
            disableSpinner />
        );
      }

      return (
        <Avatar />
      );
    },
    [
      props.fileData,
      props.initFileKey
    ]
  );



  return (
    <FileInputField.FC
      onSelectFile={props.onChangeFileData}>
      {handleClick => (
        <OuterContainerDiv>
          {props.label && (
            <Box mb={1}>
              <InputLabel>
                {props.label}
              </InputLabel>
            </Box>
          )}

          <InnerContainerDiv>
            <AvatarContainerDiv>
              {elAvatar}

              <DeleteButtonContainerDiv>
                <IconButton
                  color="primary"
                  onClick={() => props.onChangeFileData(null)}
                  disabled={props.isDisabled}>
                  <Delete />
                </IconButton>
              </DeleteButtonContainerDiv>
            </AvatarContainerDiv>

            <Button
              color="secondary"
              onClick={handleClick}
              disabled={props.isDisabled}>
              Select File
            </Button>
          </InnerContainerDiv>
        </OuterContainerDiv>
      )}
    </FileInputField.FC>
  );
};
